import { render } from "./MediaBlock.vue?vue&type=template&id=c5ee98b0&scoped=true"
import script from "./MediaBlock.vue?vue&type=script&lang=js"
export * from "./MediaBlock.vue?vue&type=script&lang=js"

import "./MediaBlock.vue?vue&type=style&index=0&id=c5ee98b0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5ee98b0"]])

export default __exports__